import { Grid } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import { usePqrDetailGeneralInfo } from './hook';
import { PqrInfoProps } from './props';
import { Accordion } from '../../../../../components/general/accordion';
import FeedIcon from '@mui/icons-material/Feed';
import DateTimePickerField from '../../../../../components/general/fields/dateTimePickerField';
import dayjs from 'dayjs';

export const PqrDetailGeneralInfo = ({ pqr }: PqrInfoProps) => {
    const { formik } = usePqrDetailGeneralInfo(pqr);
    return (
        <Accordion
            title="INFORMACIÓN GENERAL"
            icon={<FeedIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={true}
            mt={0}
        >
            <Grid
                container
                spacing={{ xs: 1.5, md: 1.5 }}
                columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            >
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="ID PQR:"
                        name="IdPQR"
                        size="small"
                        value={formik.values.consecutiveFormat}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="ID PQR SFC:"
                        name="IdPqrSfc"
                        size="small"
                        value={formik.values.sfcId}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Estado:"
                        name="status"
                        size="small"
                        value={formik.values.status}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Call ID:"
                        name="callId"
                        size="small"
                        value={formik.values.callInfo}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Ubicación PQR"
                        name="location"
                        size="small"
                        value={formik.values.location}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <DateTimePickerField
                        label="Fecha de creación"
                        name="createAt"
                        size="small"
                        value={dayjs(formik.values.created_at).subtract(
                            5,
                            'hours'
                        )}
                        disabled
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Creado por:"
                        name="userCreate"
                        size="small"
                        value={formik.values.createdBy}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Detalle PQR:"
                        name="address"
                        size="small"
                        value={formik.values.detail}
                    />
                </Grid>
            </Grid>
        </Accordion>
    );
};
